import {
  INITIALIZE,
  SET_DIRTY_FLAG_FOR_ALL,
  CLEAR_DIRTY_FLAG_FOR_ALL,
} from './AdvWorkflowCacheActions';

export default (state = {}, action) => {
  switch (action.type) {
    case INITIALIZE:
      return {
        dirtyNodesMap: {},
      };
    case SET_DIRTY_FLAG_FOR_ALL: {
      const newDirtyMap = { ...state.dirtyNodesMap };
      action.nodes.forEach((node) => {
        newDirtyMap[node] = true;
      });
      return {
        dirtyNodesMap: newDirtyMap,
      };
    }
    case CLEAR_DIRTY_FLAG_FOR_ALL: {
      const newDirtyMap = { ...state.dirtyNodesMap };
      action.nodes.forEach((node) => {
        newDirtyMap[node] = false;
      });
      return {
        dirtyNodesMap: newDirtyMap,
      };
    }
    default:
      return state;
  }
};
